theme.collectionPage =  function(){
      var addSuccess = function(itemData) {
      $.getJSON("/cart.js", function(cart) {
        // refreshCart(cart);
      });
      $('.added_btn_'+itemData.id).text('Added to cart ✓');
      $('.productAddedSuccess').text('This item is added in your cart ✓').show().css({"left": "5%", "transition": ".3s"});
    setTimeout(function(){
      $('.productAddedSuccess').text('').hide().css({"left": "-5%", "transition": ".3s"});
    }, 3000);
      
    };
  
  
    $(".sticky_add_to_cart_btn, .grid_add_btn, .list_add_btn, #AddToCart-product-template").click(function(e) { 
      e.preventDefault();
      var $add_to_cart_btn = $(this);
      var $this =$(this).parents('form:first');
      var $addToCartForm = $this;  
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(itemData) {
          $('#cart-notification').addClass('active');
          $('.remove__btn_'+itemData.id).show();
          $('.product_error_message').text('');
          $add_to_cart_btn.find('#addToCartText').text('Added');
          var count = parseInt($('#CartCount span.itemCount').text().trim() == "" ? 0 :  $('#CartCount span.itemCount').text());
          addSuccess(itemData);
          var variant_options_data =  itemData.options_with_values;
            var addedProduct = '';
          addedProduct += '<div class="cart-notification-product__image global-media-settings"> <img src="'+itemData.image+'" alt="'+itemData.product_title+'" width="70" height="70" loading="lazy"> </div>';
          addedProduct += '<div> <h3 class="cart-notification-product__name h4">'+itemData.product_title+'</h3><dl>';
          
           $.each(variant_options_data , function(index, options_value) {
           addedProduct += '<div class="product-option"> <dt>'+options_value.name+': </dt> <dd>'+options_value.value+'</dd> </div>';
          });
         addedProduct += '</dl></div>';
          $('#cart-notification-product').html(addedProduct);
          if(typeof $.fancybox != "undefined" && $.fancybox.isOpen ){$.fancybox.close();}
          $('.site-header__cart_box .site-header__cart').addClass('header_cart_hover');
          
               $('#Order_Sample-'+itemData.id).attr('disabled', 'disabled');
         $('#Order_Sample-'+itemData.id).addClass("Added_Sample");
        $('#Order_Sample-'+itemData.id).val("Added in Cart");
          setTimeout(function(){
            $add_to_cart_btn.find('#addToCartText').text('Add to Cart');
            $('.site-header__cart_box .site-header__cart').removeClass('header_cart_hover');
          }, 5000);
        },
        error: function(response){$('.over_from_in_stock_msg').show();setTimeout(function(){$('.over_from_in_stock_msg').hide();}, 5000);$addToCartForm.find('.product_error_message').html(jQuery.parseJSON(response.responseText).description).show();}
      });
      e.preventDefault(); 
    });
  
   $(document).on("click",'.cart__remove',function(){
      var obj = $(this);
      var dataToPass = 'updates['+$(this).data('itid')+']='+ 0;
      var pro_ID = $(this).data('itid');
      jQuery.post('/cart/update.js', dataToPass,function( data ) {
        //       var currencysign = $(".subtotal_amount strong").text().charAt(0); 
        addSuccess(data['items']);
        $('.added_btn_'+pro_ID).text('');
        $('.remove__btn_'+pro_ID).hide();
        $('#Order_Sample-'+pro_ID).val("Add To Cart");
         $('.productAddedSuccess').text('This item is removed from your cart.').show().css({"left": "5%", "transition": ".3s"});
    setTimeout(function(){
      $('.productAddedSuccess').text('').hide().css({"left": "-5%", "transition": ".3s"});
    }, 3000);
         $('#Order_Sample-'+pro_ID).removeAttr( "disabled" );
         $('#Order_Sample-'+pro_ID).removeClass("Added_Sample");
      }, "json");
    }); 

   

}
$(function(){
   theme.collectionPage();
});